import { CardContent } from '@mui/material';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import React from 'react';
import { CountrySelector } from '../CountrySelector';
import { CategorySelect } from './CategorySelect';
import { DiscountStatusSelector } from './DiscountStatusSelector';
import DateInput from '../input/DateInput';
import { PatientTypeSelect } from '../PatientTypeSelect';

export const DiscountFilters = ({filters, disabled, changeFilters}) => {
    return <Card sx={{backgroundColor: '#f4f4f4', marginBottom: 1}}>
        <CardContent>
            <CountrySelector
                disabled={disabled}
                label="Country"
                onChange={country => changeFilters({country: country?.code || null})}
            />
            <DiscountStatusSelector
                disabled={disabled}
                label="Status"
                onChange={status => changeFilters({status})}
            />
            <CategorySelect
                disabled={disabled}
                label="Product category"
                onChange={category => changeFilters({category})}
            />
            <PatientTypeSelect
                disabled={disabled}
                label="Patient type"
                onChange={patientType => changeFilters({patientType})}
            />
            <Grid container>
                <Grid item lg={6} md={6} sm={6}>
                    <DateInput
                        label="Created from"
                        value={filters.createdFrom}
                        onChange={createdFrom => changeFilters({createdFrom})}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6}>
                    <DateInput
                        label="to"
                        value={filters.createdTo}
                        onChange={createdTo => changeFilters({createdTo})}
                        disabled={disabled}
                    />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
}
